import { takeEvery, call, put, select, all } from 'redux-saga/effects';
import {
  updateList,
  sendRequest,
  selectQueryParams,
  initState
} from '../../../../common/reducers/_list/reducer';
import {
  requestInProcess,
  requestFinished,
  setCodeResponse,
  initState as initRequestStatusState
} from '../../../../common/reducers/_requestStatus/reducer';
import {
  setPagination,
  initState as initPaginationState
} from '../../../../common/reducers/_pagination/reducer';
import { childCommentsReduceName } from './reducer';
import {
  updateList as updateChildCommentList,
  initState as initchildMultipleListState
} from '../../../../common/reducers/__childMultipleList/reducer';
import { timeoutCall } from '../../../../utils/sagaHalper';
import CommentsService from '../../services';

function* getCommentLists(reducerName) {
  const queryParams = yield select(selectQueryParams, reducerName);
  yield put(requestInProcess(reducerName));
  try {
    const result = yield call(
      timeoutCall,
      CommentsService.getCommentsList,
      queryParams
    );
    if (result.response) {
      yield put(setCodeResponse(reducerName, result.response.status));
      if (result.response.status) {
        yield put(setPagination(reducerName, result.destructData.pagination));
        yield put(
          updateList(reducerName, {
            itemsById: result.destructData.commentsById,
            itemsIds: result.destructData.commentsIds
          })
        );
        yield put(
          updateChildCommentList(reducerName, childCommentsReduceName, {
            childItemsById: result.destructData.childCommentsById,
            parentsMapIds: result.destructData.childCommentsMapParent
          })
        );
      }
    }
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName));
}

function* initStates(reducerName) {
  yield put(initRequestStatusState(reducerName));
  yield put(initPaginationState(reducerName));
  yield put(initchildMultipleListState(reducerName, childCommentsReduceName));
}

export default function* createSaga(reducerName) {
  yield all([
    takeEvery(sendRequest(reducerName).type, getCommentLists, reducerName),
    takeEvery(initState(reducerName).type, initStates, reducerName)
  ]);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/comments/reducers/list/saga.js